import * as React from 'react';

const ToastContainer = ({ appearance, children }) => (
    <div className="toast-container">{children}</div>
);

export default ToastContainer;
